import { render, staticRenderFns } from "./config023-f-movies.vue?vue&type=template&id=352a14c3&"
import script from "./config023-f-movies.vue?vue&type=script&lang=js&"
export * from "./config023-f-movies.vue?vue&type=script&lang=js&"
import style0 from "./config023-f-movies.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports